Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityMetricView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_metric']
  detailsTemplate: JST['backbone/templates/customer/reports/operator_availability/operator_availability_metric_details']
  className: 'operator-availability-metric'

  events:
    'click .details-selector': '_onDetailsSelectorClick'

  initialize: ({@metric}) ->
    @showDetails = false
    if @metric.types && @metric.types.length > 1
      notEmptyTypes = @metric.types.filter((type) -> type.count > 0)
      if notEmptyTypes.length > 0
        @detailsHtml = @detailsTemplate(types: notEmptyTypes)
        @showDetails = true

  render: ->
    @$el.html(
      @template(
        title: @metric.title,
        count: @_withThousandsSeparator(@metric.count),
        showDetails: @showDetails
      )
    )
    @$el.addClass(@metric.className) if @metric.className
    @_initializeDetailsPopover() if @showDetails
    @

  _initializeDetailsPopover: ->
    @_detailsSelectorEl().popover
      placement: 'bottom'
      content: @detailsHtml
      html: true

    observer = new MutationObserver(@_fixPopoverPosition)
    observer.observe(@$el.get(0), childList: true, subtree: true)

  _withThousandsSeparator: (number) ->
    number.toLocaleString()

  _onDetailsSelectorClick: ->
    detailsSelectorEl = @_detailsSelectorEl()
    detailsSelectorEl.toggleClass('fa-chevron-down')
    detailsSelectorEl.toggleClass('fa-chevron-up')

  _fixPopoverPosition: (mutationList) ->
    popoverEl = mutationList[0].addedNodes[0]
    return unless popoverEl

    $popover = $(popoverEl)
    popoverWidth = $popover.width()
    popoverLeftPosition = $popover.position().left
    viewportWidth = document.documentElement.clientWidth

    return if popoverWidth + popoverLeftPosition < viewportWidth

    margin = 10
    newLeftPosition = viewportWidth - popoverWidth - margin
    $popover.css('left', newLeftPosition)

  _detailsSelectorEl: ->
    @$el.find('.details-selector')
